import { render, staticRenderFns } from "./ShipbluCursorPagination.vue?vue&type=template&id=4a1a7572"
import script from "./ShipbluCursorPagination.vue?vue&type=script&lang=js"
export * from "./ShipbluCursorPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports